import { createSelector } from '@reduxjs/toolkit';
import { Line } from 'components/common/types/Deal.types';
import { Store } from 'components/common/types/Store.types';

export const getProgrammaticLinesWithCurrent = createSelector(
  (state: Store) => state.dealManagement.backupFormData.lines,
  (state: Store) => state.dealManagement.commonDeal.currentLine,
  (backupFormDataLines, currentLine): Line[] => {
    if (!backupFormDataLines.length) {
      return [currentLine];
    }

    const isCurrentLineInBackup = backupFormDataLines.some((line) => line.id === currentLine?.id);

    return isCurrentLineInBackup ? backupFormDataLines : backupFormDataLines.concat([currentLine]);
  },
);
